import part from '@assets/curved_ticket.png';

export const ArcadeTicketIcon = () => {
  return (
    <img
      src={part}
      className='h-[18px] w-[18px]'
      alt='Puzzle Arcade Ticket ($PART) logo'
    />
  );
};
